import * as Yup from "yup";

const segmentoValidator = Yup.object().shape({
  ativado: Yup.boolean().nullable(),
  descricao: Yup.string().required("Descrição"),
});

export default segmentoValidator;
